import { render, staticRenderFns } from "./AdGuardHome.vue?vue&type=template&id=4c1b556c&scoped=true&"
import script from "./AdGuardHome.vue?vue&type=script&lang=js&"
export * from "./AdGuardHome.vue?vue&type=script&lang=js&"
import style0 from "./AdGuardHome.vue?vue&type=style&index=0&id=4c1b556c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1b556c",
  null
  
)

export default component.exports